'use client';

import { useOnceEffect } from '@/hooks/useOnceEffect';
import type { KakaoPixelCall } from '@/utils/analytics/kakao-pixel';
import { trackKakaoPixelEvent } from '@/utils/analytics/kakao-pixel';

export const KakaoPixelEventTrigger = ({
  pixelId,
  event,
}: {
  pixelId: string;
  event: KakaoPixelCall;
}) => {
  useOnceEffect(() => {
    trackKakaoPixelEvent(pixelId, ...event);
  });

  return null;
};
